'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _AuthAdminSelectors = require('pricing-pages-unified-ui/selectors/AuthAdminSelectors');

var _ConfigSelectors = require('pricing-pages-unified-ui/selectors/ConfigSelectors');

var _Loadable = require('UIComponents/decorators/Loadable');

var _Loadable2 = _interopRequireDefault(_Loadable);

var _reactRouterDom = require('react-router-dom');

var _params = require('hub-http/helpers/params');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublicApplicationComponents = (0, _Loadable2.default)({
  loader: function loader() {
    return import( /* webpackChunkName: "PublicApplicationComponents" */'pricing-pages-unified-ui/containers/PublicApplicationComponents');
  },
  LoadingComponent: function LoadingComponent() {
    return null;
  }
});

var isHubSpotDotComAuthedUserRedirect = function isHubSpotDotComAuthedUserRedirect() {
  // Has to work for different TLDs, e.g. www.hubspot.jp
  var WWW_REFERRER_SUBSTRING = 'www.hubspot.';
  var BR_REFERRER_SUBSTRING = 'br.hubspot.';
  // If you have multiple portals, you go from public pricing -> portal picker page -> in-app page. This is not perfect detection
  // as it will pick up ANY time you short link to pricing, regardless
  // of origin, but this is likely CloseEnough.
  var PORTAL_PICKER_REFERRER_SUBSTRING = 'https://app.hubspot.com/portal-recommend/l?slug=pricing';
  var QA_TEST_REFERRER_SUBSTRING = '/public-pricing';

  var _document = document,
      referrer = _document.referrer;


  return Boolean(referrer.indexOf(WWW_REFERRER_SUBSTRING) > -1 || referrer.indexOf(BR_REFERRER_SUBSTRING) > -1 || referrer.indexOf(QA_TEST_REFERRER_SUBSTRING) > -1 || referrer.indexOf(PORTAL_PICKER_REFERRER_SUBSTRING) > -1);
};

var _getUpgradeSourceFromQuery = function _getUpgradeSourceFromQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var upgradeSource = void 0;

  if (query) {
    if (query.upgradeSource) {
      upgradeSource = decodeURIComponent(query.upgradeSource);
    } else if (query.upgradesource) {
      // shortlinks will lowercase passthrough query params so we have to check both
      upgradeSource = decodeURIComponent(query.upgradesource);
    }
  }

  return upgradeSource;
};

var Application = function Application(_ref) {
  var children = _ref.children,
      isAppAuth = _ref.isAppAuth,
      location = _ref.location,
      isBillingAdmin = _ref.isBillingAdmin;

  (0, _react.useEffect)(function () {
    var upgradeSource = _getUpgradeSourceFromQuery((0, _params.parse)(location.search.slice(1)));
    (0, _getUsageTracker2.default)().setProperties({
      isBillingAdmin: isBillingAdmin,
      upgradeSource: upgradeSource,
      inAppOrPublic: isAppAuth ? 'in-app' : 'public',
      isDotComAuthedRedirect: isAppAuth && isHubSpotDotComAuthedUserRedirect()
    });
  }, []);

  if (isAppAuth) {
    if (isHubSpotDotComAuthedUserRedirect()) {
      // If we came from public hubspot.com/pricing render the dot com marketing nav.
      // This represents authenticated users who go to the website pricing pages
      // We want to preserve the dot com nav since otherwise it would lead to a weird
      // experience where they'd lose their nav and couldnt go back without using the
      // browser back button
      return _react2.default.createElement(
        PublicApplicationComponents,
        { isLoggedIn: true },
        _react2.default.createElement(
          'div',
          { className: 'app-auth-marketing-nav-wrapped-page' },
          children
        )
      );
    } else {
      return _react2.default.createElement(
        'div',
        null,
        children
      );
    }
  } else {
    return _react2.default.createElement(
      PublicApplicationComponents,
      { isLoggedIn: false },
      children
    );
  }
};

Application.propTypes = {
  children: _react.PropTypes.node.isRequired,
  isBillingAdmin: _react.PropTypes.bool.isRequired,
  location: _react.PropTypes.shape({
    query: _react.PropTypes.object
  }),
  isAppAuth: _react.PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    isBillingAdmin: (0, _AuthAdminSelectors.isBillingAdminSelector)(state),
    isAppAuth: (0, _ConfigSelectors.isAppAuthSelector)(state)
  };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Application));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/containers/Application.js
// module id = 641
// module chunks = 3 4